module.exports = __webpack_public_path__ + "img/Engagement_Moderately_Engaged_32.f0a79ebe.png";